import { initStore } from './store';

const configStore = () => {
  const actions = {
    SET: (curState, newState) => {
      return { ...curState, ...newState };
    },
    CLEAR_SELECTION: (curState) => {
      return {
        ...curState,

      }
    }
  };
  initStore(actions, {
    orderData: false,
    orderLines: [],
    delivery: {},
    orderID: null,
    firstName: null,
    lastName: null,
    email: null,
    purchaseDate: null,
    errorMessages: null,
    modalIsOpen: false,
    selectedDateTime: null,
    selectedDate: null,
    selectedTime: null,
    eventID: null,
    orderDesc: null,
    adultTickets: 0,
    childTickets: 0,
    family1Tickets: 0,
    family2Tickets: 0,
    isfam_2_2: false,
    isfam_1_3: false
  });
};

export default configStore;
